// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodBenchmarkId } from './FoodBenchmark';
import { z } from 'zod';
export const foodBenchmarkIngredientId = (z.number());
export const foodBenchmarkIngredient = z.object({
    id: foodBenchmarkIngredientId,
    benchmark_id: foodBenchmarkId,
    display_order: z.number(),
    name: z.string(),
});
export const foodBenchmarkIngredientInitializer = z.object({
    id: foodBenchmarkIngredientId.optional(),
    benchmark_id: foodBenchmarkId,
    display_order: z.number().optional(),
    name: z.string(),
});
export const foodBenchmarkIngredientMutator = z.object({
    id: foodBenchmarkIngredientId.optional(),
    benchmark_id: foodBenchmarkId.optional(),
    display_order: z.number().optional(),
    name: z.string().optional(),
});
//# sourceMappingURL=FoodBenchmarkIngredient.js.map